/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/RcVideo';
export default {
  scheduleFor: 'Schedule on behalf of',
  scheduleForAssistedUser: 'Update meeting settings on behalf of {userName}.',
  scheduleForGuidance:
    'Scheduling for someone else?\n1. Make sure you’re on their Outlook calendar.\n2. From the dropdown, select the person you’re scheduling for.\n',
  scheduleForGuidanceMore: 'Learn details',
  meetingSettings: 'Meeting settings',
  meetingSettingsDescription: 'Updates will apply to this meeting only.',
  [ASSISTED_USERS_MYSELF]: 'Myself',
  waitingRoomTitle: 'Use waiting room',
  waitingRoomDescription:
    'Participants wait until you admit them. Great for interviews or outside attendees.',
  waitingRoomNotCoworker: 'For anyone outside my company',
  waitingRoomGuest: 'For anyone not signed in',
  waitingRoomAll: 'For all participants',
  enterPassword: 'Enter Password',
  onlyJoinAfterMe: 'Start meeting after you join',
  allowJoinBeforeHostDescription:
    'The meeting will start after you join to prevent early conversations.',
  requirePassword: 'Require password',
  requirePasswordDescription:
    'Keep your meeting secure. Anyone using the link won’t be prompted for a password.',
  password: 'Password:',
  passwordEmptyError: 'Meeting password required',
  passwordInvalidError:
    'Your password must be 1–10 letters and numbers long but cannot contain symbols',
  passwordHintText:
    'Your password should be 1–10 letters and numbers long, but cannot contain symbols.',
  usePersonalMeetingIdInstead: 'Use personal meeting link',
  allowMeetingAccess: 'Manage who can join',
  anyoneWithLink: 'Anyone with link',
  signedInUsers: 'Only {shortName} accounts',
  signedInCoWorkers: 'Only my coworkers',
  passwordLabel: 'Password',
  edit: 'Edit',
  editSettings: 'Edit settings',
  lockTooltip: 'This setting is managed by your company admin',
  cancel: 'Cancel',
  update: 'Update',
  pmiSettingsTitle: 'Personal meeting settings',
  pmiSettingsDescription:
    'Set who can join and how for your personal meeting link.',
} as const;

// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"scheduleForAssistedUser"@#@ @source: @#@"Update meetings settings on behalf of {userName}."@#@
// @key: @#@"scheduleForGuidance"@#@ @source: @#@"Scheduling for someone else?\n1. Make sure you're on their Outlook calendar.\n2. From the dropdown, select the person you're scheduling for.\n"@#@
// @key: @#@"scheduleForGuidanceMore"@#@ @source: @#@"Learn details"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"meetingSettingsDescription"@#@ @source: @#@"Updates will apply to this meeting only."@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"waitingRoomTitle"@#@ @source: @#@"Use waiting room"@#@
// @key: @#@"waitingRoomDescription"@#@ @source: @#@"Participants wait until you admit them. Great for interviews or outside attendees."@#@
// @key: @#@"waitingRoomNotCoworker"@#@ @source: @#@"For anyone outside my company"@#@
// @key: @#@"waitingRoomGuest"@#@ @source: @#@"For anyone not signed in"@#@
// @key: @#@"waitingRoomAll"@#@ @source: @#@"For all participants"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"onlyJoinAfterMe"@#@ @source: @#@"Start meeting after you join"@#@
// @key: @#@"allowJoinBeforeHostDescription"@#@ @source: @#@"The meeting will start after you join to prevent early conversations."@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"requirePasswordDescription"@#@ @source: @#@"Keep your meeting secure. Anyone using the link won't be prompted for a password."@#@
// @key: @#@"password"@#@ @source: @#@"Password:"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"passwordInvalidError"@#@ @source: @#@"Your password must be 1-10 letters and numbers long but cannot contain symbols"@#@
// @key: @#@"passwordHintText"@#@ @source: @#@"Your password should be 1-10 letters and numbers long, but can not contain symbols."@#@
// @key: @#@"usePersonalMeetingIdInstead"@#@ @source: @#@"Use personal meeting link"@#@
// @key: @#@"allowMeetingAccess"@#@ @source: @#@"Manage who can join"@#@
// @key: @#@"anyoneWithLink"@#@ @source: @#@"Anyone with link"@#@
// @key: @#@"signedInUsers"@#@ @source: @#@"Only {shortName} accounts"@#@
// @key: @#@"signedInCoWorkers"@#@ @source: @#@"Only my coworkers"@#@
// @key: @#@"passwordLabel"@#@ @source: @#@"Password"@#@
// @key: @#@"edit"@#@ @source: @#@"Edit"@#@
// @key: @#@"editSettings"@#@ @source: @#@"Edit settings"@#@
// @key: @#@"lockTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"update"@#@ @source: @#@"Update"@#@
// @key: @#@"pmiSettingsTitle"@#@ @source: @#@"Personal meeting settings"@#@
// @key: @#@"pmiSettingsDescription"@#@ @source: @#@"Set who can join and how for your personal meeting link."@#@
